import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, tap, catchError } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { BASE_URL } from '../../config/config';
import { NgxSpinnerService } from "ngx-spinner";
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})

export class AlertsService {
  public DASBOARD_URL = BASE_URL.URL;

  constructor(
    private http: HttpClient,
    private spinnerService: NgxSpinnerService,
    private route: Router
  ) { }

  getalerts(): Observable<any> {
    this.spinnerService.show();
    let token = localStorage.getItem('token');

    return this.http.get(`${this.DASBOARD_URL}/alerts?is_closed=0`, {
      headers: {
        'Authorization': 'Bearer ' + token
      }
    })
      .pipe(
        map((res: any) => {
          return res
        }), 
        tap(err => this.spinnerService.hide()), 
        catchError(this.handleError.bind(this)) 
      );
  }

  getalertList(currentPage: number, type: Array<String> = [], status: Array<Number> = [], raisedSortValue: String, resolvedSortValue: String): Observable<any> {
    this.spinnerService.show();
    let token = localStorage.getItem('token');
    return this.http.get(`${this.DASBOARD_URL}/alerts?page=${currentPage}${type.length > 0 ? `&type=${type}` : ''}${status.length > 0 ? `&is_closed=${status}` : ''}${raisedSortValue ? `&raised_at=${raisedSortValue}` : ''}${resolvedSortValue ? `&resolved_at=${resolvedSortValue}` : ''}`, {
      headers: {
        'Authorization': 'Bearer ' + token
      } 
    })
      .pipe(
        map((res: any) => {
          return res
        }),
        tap(err => this.spinnerService.hide()),
        catchError(this.handleError.bind(this))
      );
  }

  closeAlert(alertId: number): Observable<any> {
    this.spinnerService.show();
    let token = localStorage.getItem('token');

    return this.http.get(`${this.DASBOARD_URL}/alerts/${alertId}/close`, {
      headers: {
        'Authorization': 'Bearer ' + token
      }
    })
      .pipe(
        map((res: any) => {
          return res
        }),
        tap(err => this.spinnerService.hide()),
        catchError(this.handleError.bind(this))
      );
  }



  private handleError(error: any){
    if (error.status === 401) {
      localStorage.clear();
      this.route.navigateByUrl(`/login?redirect_link=${this.route.url}`);
      this.spinnerService.hide();
      return
    }else{
      this.spinnerService.hide();
      return throwError(()=> error);
    }
  }

}
